import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  FieldSet: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  Time: { input: any; output: any; }
  _Any: { input: any; output: any; }
  federation__Policy: { input: any; output: any; }
  federation__Scope: { input: any; output: any; }
};

export type AssociatedSchedule = {
  __typename?: 'AssociatedSchedule';
  id: Scalars['ID']['output'];
};

export enum CalendarType {
  Broadcast = 'BROADCAST',
  Standard = 'STANDARD'
}

export type CreateFolderResponse = {
  __typename?: 'CreateFolderResponse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FeatureModuleAuth = {
  __typename?: 'FeatureModuleAuth';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nations: Array<Maybe<NationAuth>>;
};

/** Holds user folder information */
export type Folder = {
  __typename?: 'Folder';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['ID']['output']>;
  reports?: Maybe<Array<UserReport>>;
  schedules?: Maybe<Array<ReportScheduleSummary>>;
};

export type IdNamePair = {
  __typename?: 'IDNamePair';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Api to delete a folder and its sub-folders. Returns 1 if the folder and its subfolder are deleted;
   * Returns USER_INPUT_ERROR if
   * - the folder is not found for the user OR
   * - the folder or any of its sub-folders are not empty
   */
  deleteFolder: Scalars['Int']['output'];
  saveFolder: SaveResponse;
  /**
   * Sets the folder ID associated with the report.  Folder ID may be null
   * to make the report not associated with any folder.  Returns true if the
   * operation was successful, false otherwise.
   */
  setReportFolder: Scalars['Boolean']['output'];
  setScheduleFolder: Scalars['Boolean']['output'];
};


export type MutationDeleteFolderArgs = {
  folderId: Scalars['Int']['input'];
};


export type MutationSaveFolderArgs = {
  saveFolderCriteria: SaveFolderInput;
};


export type MutationSetReportFolderArgs = {
  reportFolderInput: SetReportFolderInput;
};


export type MutationSetScheduleFolderArgs = {
  scheduleFolderInput: SetScheduleFolderInput;
};

export type NationAuth = {
  __typename?: 'NationAuth';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<ProductAuth>>>;
};

/** PeriodAggregationEnum is the set of aggregation level values for data aggregation on periods */
export enum PeriodAggregationEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ProductAuth = {
  __typename?: 'ProductAuth';
  hasSchedulerAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reports: Array<Maybe<Scalars['Int']['output']>>;
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  findAllUserFolders?: Maybe<Array<Folder>>;
  getUserAuth: Array<Maybe<FeatureModuleAuth>>;
};

/** ReportExportFormatEnum is the set of file format supported in the report exporting */
export enum ReportExportFormatEnum {
  ColonDelimited = 'COLON_DELIMITED',
  CommaDelimited = 'COMMA_DELIMITED',
  Excel = 'Excel',
  SemicolonDelimited = 'SEMICOLON_DELIMITED',
  TabDelimited = 'TAB_DELIMITED',
  VerticalbarDelimited = 'VERTICALBAR_DELIMITED'
}

/** ReportScheduleSummary */
export type ReportScheduleSummary = {
  __typename?: 'ReportScheduleSummary';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expireDateTime: Scalars['Time']['output'];
  fileFormat: ReportExportFormatEnum;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recurrencePattern: Scalars['String']['output'];
  source: Scalars['String']['output'];
  startDateTime: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

/** Api to save a folder */
export type SaveFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response type carrying the saved name in case it is different from the one sent along with the id. */
export type SaveResponse = {
  __typename?: 'SaveResponse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ServerErrorCode {
  BadUserInput = 'BAD_USER_INPUT',
  Forbidden = 'FORBIDDEN',
  InternalSystemError = 'INTERNAL_SYSTEM_ERROR',
  ReportNameExists = 'REPORT_NAME_EXISTS',
  ReportNotFound = 'REPORT_NOT_FOUND',
  ScheduleNameExists = 'SCHEDULE_NAME_EXISTS',
  ScheduleNotFound = 'SCHEDULE_NOT_FOUND',
  Unauthenticated = 'UNAUTHENTICATED'
}

export type SetReportFolderInput = {
  folderID?: InputMaybe<Scalars['ID']['input']>;
  reportId: Scalars['ID']['input'];
};

export type SetScheduleFolderInput = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  scheduleId: Scalars['ID']['input'];
};

/** StringComparisonEnum is the set of valid options for custom filter strings. */
export enum StringComparisonEnum {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  None = 'NONE',
  StartsWith = 'STARTS_WITH'
}

/** UserReport is the type returned by the list user reports API. */
export type UserReport = {
  __typename?: 'UserReport';
  associatedSchedules: Array<Maybe<AssociatedSchedule>>;
  created: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresOn: Scalars['Int']['output'];
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nationId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  shared: Scalars['Boolean']['output'];
  typeId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};
